import { useRouter } from 'next/router';
// Types
import { GetStream_stream } from 'api/streams/types/GetStream';
// Helpers
import { getStreamSocialShareText, getStreamerName } from 'helpers/streams';
import { getEnvLink, computeShopPath } from 'helpers/routes';
// Components
import SocialShareQRButton from 'ui3/SocialShareQRButton/SocialShareQRButton';
// UI3
import LinkButton from 'ui3/LinkButton/LinkButton';
import Button from 'ui3/Button/Button';
// Styles
import styles from './StreamFanActionButtons.module.scss';

type StreamFanActionButtonsProps = {
  stream: GetStream_stream;
  isStreamEnded: boolean;
  onTipModalToggle: () => void;
};

const StreamFanActionButtons = ({
  stream,
  isStreamEnded,
  onTipModalToggle,
}: StreamFanActionButtonsProps): JSX.Element => {
  const router = useRouter();
  const streamerName = getStreamerName(stream.store);
  const socialShareButtonText = getStreamSocialShareText(
    false,
    isStreamEnded,
    streamerName
  );
  const merchLink = getEnvLink() + computeShopPath(stream.store);

  return (
    <>
      <SocialShareQRButton
        modalTitle="Share Stream"
        modalText="Share this stream with your friends"
        path={router.asPath}
        twitterText={socialShareButtonText}
        icon
        size="medium"
      />

      <Button
        variant="secondary"
        size="medium"
        onClick={onTipModalToggle}
        icon="tipHand"
        className={styles.hypeButton}
      >
        Tip
      </Button>

      <LinkButton
        variant="secondary"
        link={merchLink}
        size="medium"
        target="_blank"
        icon="shoppingWallet"
      >
        Shop
      </LinkButton>
    </>
  );
};

export default StreamFanActionButtons;
